import React, {
  useContext,
  useEffect
} from 'react'

import { useRouter } from 'next/router'

import useMouse from 'hooks/useMouse'
import useIsMobile from 'hooks/useIsMobile'

import { MouseContext } from 'contexts/Mouse'

import colors from 'theme/colors'

import { StyledCursor } from './styles'

const Cursor = () => {
  const isMobile = useIsMobile()
  const router = useRouter()
  const {
    cursorType,
    cursorText,
    cursorBlendMode,
    cursorChangeType,
    cursorChangeText,
    cursorChangeBlendMode,
    mouseVisible,
  } = useContext(MouseContext)

  const { mousePos, } = useMouse()

  const {
    posX,
    posY
  } = mousePos

  let mouseXPosition = 0
  let mouseYPosition = 0

  if (posX !== null) {
    mouseXPosition = posX
  }

  if (posY !== null) {
    mouseYPosition = posY
  }


  useEffect(() => {
    if (!mouseVisible || isMobile) return cursorChangeType('hidden')

    const cType = cursorType === 'hidden' ? 'default' : cursorType
    return cursorChangeType(cType)
  }, [mouseVisible, isMobile])

  useEffect(() => {
    const handleRouteChange = () => {
      cursorChangeText()
      cursorChangeType()
      cursorChangeBlendMode()
    }

    router.events.on('routeChangeStart', handleRouteChange)

    return () => {
      router.events.off('routeChangeStart', handleRouteChange)
    }
  }, [router.events])


  const spring = {
    type: 'spring',
    stiffness: 500,
    damping: 28
  }

  const variants = {
    default: {
      mixBlendMode: 'difference',
      opacity: 0,
      x: mouseXPosition,
      y: mouseYPosition,
      height: 0,
      width: 0,
      transition: {
        type: 'spring',
        mass: 0.1
      },
    },
    invertedLink: mixBlendMode => ({
      mixBlendMode,
      opacity: 1,
      backgroundColor: colors.white,
      color: colors.black,
      x: mouseXPosition - 70,
      y: mouseYPosition - 70,
      height: 140,
      width: 140,
      transition: {
        type: 'spring',
        mass: 0.1
      },
    }),
    defaultLink: mixBlendMode => ({
      mixBlendMode,
      opacity: 1,
      backgroundColor: colors.primary,
      color: colors.white,
      x: mouseXPosition - 70,
      y: mouseYPosition - 70,
      height: 140,
      width: 140,
      transition: {
        type: 'spring',
        mass: 0.1
      },
    }),
    scaleUp: {
      mixBlendMode: 'difference',
      opacity: 1,
      x: mouseXPosition - 22.5,
      y: mouseYPosition - 22.5,
      height: 50,
      width: 50,
      transition: {
        type: 'spring',
        mass: 0.1
      },
    },
    hidden: {
      opacity: 0,
      padding: 0,
      width: 0,
      height: 0,
      x: mouseXPosition,
      y: mouseYPosition,
    }
  }

  return (
    !isMobile ?
      <StyledCursor
        custom={cursorBlendMode}
        variants={variants}
        animate={cursorType}
        transition={spring}
      >
        <span className="cursorText">{cursorText}</span>
      </StyledCursor>
      : null
  )
}


export default Cursor
